'use client'
import { useRef } from 'react'
import clsx from 'clsx'
import Flex from '@/components/atoms/Flex'
import Container from '@/components/atoms/Container'
import { Display, Paragraph } from '@/components/atoms/Typography'

import HeroActions from '@/components/molecules/Hero/HeroActions'
import ScrollDown from '@/components/molecules/ScrollDown'
import Deadline from '@/components/molecules/Deadline'

import { DocType } from '@/types/Content.types'
import styles from './HeroMain.module.scss'

const HeroMain = ({
  title,
  abstract,
  deadline,
  docs,
  withActions,
  withScrollDown,
  isCompetition,
  applyLink,
  comingSoon = false,
}: {
  title: string | undefined
  abstract?: string
  deadline?: string
  docs?: DocType[]
  withActions?: boolean
  withScrollDown?: boolean
  isCompetition?: boolean
  applyLink?: string
  comingSoon?: boolean
}) => {
  const scrollDownRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={clsx(
        styles.heroContent,
        isCompetition && styles.heroContentCompetition
      )}
      ref={scrollDownRef}
    >
      <Flex
        alignItems='end'
        className={styles.heroContentInner}
      >
        <Container>
          <Flex
            gap='2rem'
            direction='column'
            alignItems='start'
          >
            {deadline && <Deadline deadline={deadline} />}

            <Flex
              direction='column'
              alignItems='start'
              justifyContent='end'
              gap='2rem'
              fullWidth
            >
              <Display
                as={'h1'}
                size='lg'
                weight='bold'
                dangerouslySetInnerHTML
                content={title}
              />

              {!!abstract && (
                <Flex
                  gap='2rem'
                  justifyContent='between'
                  alignItems='end'
                  fullWidth
                >
                  {!!abstract && (
                    <Paragraph
                      className={styles.abstract}
                      size='lg'
                      weight='regular'
                      dangerouslySetInnerHTML
                      content={abstract}
                    />
                  )}
                  {withScrollDown && <ScrollDown targetRef={scrollDownRef} />}
                </Flex>
              )}
            </Flex>

            {withActions && docs && !!docs.length && (
              <HeroActions
                docs={docs}
                applyLink={applyLink}
                comingSoon={comingSoon}
              />
            )}
          </Flex>
        </Container>
      </Flex>
    </div>
  )
}

export default HeroMain
